const adjustCountryDropdownItems = (items) => {
    const adjustedItems = [];
    items.map((el) => {
        // TODO remove this fix
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const obj = { ...el };
        obj.label = `${el.country}${el.lang ? ' / ' + el.lang : ''}`;
        obj.options = {
            country: obj.country,
            countryCode: obj.countryCode,
            lang: obj.lang,
        };
        delete obj.country;
        delete obj.countryCode;
        delete obj.lang;
        adjustedItems.push(obj);
    });
    return adjustedItems;
};

export { adjustCountryDropdownItems };
//# sourceMappingURL=index.js.map
